import React from 'react';
import { ReactComponent as PdfOK } from '../../assets/images/icons/pdfOK.svg';

export default function PdfOKIcon(props) {
  return (
    <PdfOK {...props} className={'icon'} />
  );
}
